import {createSvgIcon} from '../create-svg-icon';

export const MoreIcon = createSvgIcon(
  [<path d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14z" key="0" />,<circle cx="9" cy="12" r="1.5" key="1" />,<circle cx="14" cy="12" r="1.5" key="2" />,<circle cx="19" cy="12" r="1.5" key="3" />,]
, 'MoreOutlined');
